/**
 * Helper function to get stored question answer in the session.
 */
export const getStoredQuestion = (aqid) => {
  const storedQuestions = JSON.parse(window.sessionStorage.getItem('Anu.questions') ?? '{}');
  return storedQuestions[aqid];
}

/**
 * Helper function to store question answer in the session.
 */
export const setStoredQuestion = (aqid, value) => {
  const storedQuestions = JSON.parse(window.sessionStorage.getItem('Anu.questions') ?? '{}');
  storedQuestions[aqid] = value;
  window.sessionStorage.setItem('Anu.questions', JSON.stringify(storedQuestions));
}
